import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey, RoutesMap } from "../types"
import { changeStatus, onSetSelectedSubCategory, onFetchSubcategoriesWithProduct, selectSubCategoryState, setAction } from "../redux/slices/subcategorySlice"
import { Subcategory } from "../types/slices/subcategoryType"
import { SubCategoryAPI } from "../apis/SubCategoryAPI"
import { useLocation } from 'react-router-dom';

export const useSubcategoryStore = () => {

    const dispatch = useDispatch()
    const { subCategories, subcategoriesWithProducts, subCategorySelected, status, action } = useSelector(selectSubCategoryState)

    const { pathname } = useLocation()
    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getSubCategories = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.getSubCategories({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSubcategoriesByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.getSubcategoriesByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSubcategoriesDuplicated = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.getSubcategoriesDuplicated({idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getReviewData = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.getReviewData({idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSubcategoriesWithProducts = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.getSubcategoriesWithProducts({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchSubcategoriesWithProduct(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getSubcategoriesByCategory = async (search='', idcategory:number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.getSubcategoriesByCategory({search:search, idcategory:idcategory, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                if(pathname != RoutesMap.PRICE_LIST) CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createSubCategory = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.createSubCategory({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const unifyDuplicated = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.unifyDuplicated(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editSubCategory = async (idsubcategory: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.editSubCategory(idsubcategory, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteSubCategory = async (idsubcategory: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SubCategoryAPI.deleteSubCategory(idsubcategory)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedSubCategory = (subcategory: Subcategory) => {
        try {
            dispatch(onSetSelectedSubCategory(subcategory))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionSubCategory = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        subCategories,
        subcategoriesWithProducts,
        subCategorySelected,
        status,
        action,
        //actions
        getSubCategories,
        getSubcategoriesByCompany,
        getSubcategoriesWithProducts,
        getSubcategoriesDuplicated,
        getReviewData,
        getSubcategoriesByCategory,
        createSubCategory,
        unifyDuplicated,
        editSubCategory,
        deleteSubCategory,
        setSelectedSubCategory,
        setActionSubCategory,
    }
}